import { BomNode } from "@/features/job-tracking/queries/tracking-data/bom-hierarchy-generator";
import { CostTaxBreakdown } from "@/features/job-tracking/queries/tracking-data/cost-tax-breakdown";
import { EstimateLineItem } from "../../queries/estimate";

export interface TableLineItem extends EstimateLineItem {
  bomHierarchyNode: BomNode;
  labour: CostTaxBreakdown;
  cogs: CostTaxBreakdown;
  total: CostTaxBreakdown;
}

export function processTableRow(line: EstimateLineItem, index: number, bomHierarchy: BomNode[]): TableLineItem {
  const bomHierarchyNode = bomHierarchy[index]!;
  const total = bomHierarchyNode.lineItemCost;
  const labour = bomHierarchyNode.categorizedLineItemCosts.labour;
  const cogs = total.subtract(labour);
  return { ...line, bomHierarchyNode, labour, cogs, total };
}
